import ApiService from "@/common/api.service";
import { COMPANY_ID } from "@/common/config.js";

import {
  GET_NEW_PRODUCT,
  GET_PRODUCTS_BY_TAG_ID,
  GET_PRODUCTS_BY_PUBLIC_TAGS_NAME,
  GET_PRODUCTS_BY_PUBLIC_CATEGORY_NAME,
  GET_PRODUCTS_BY_PUBLIC_CATEGORY_NAME_WITH_SORT,
  GET_PRODUCTS_BY_PUBLIC_TAGS_NAME_WITH_SORT
} from "./actions.type";
import { SET_NEW_PRODUCT, SET_PRODUCT_LIST } from "./mutations.type";

const state = {
  errors: {},
  newProduct: null,
  productList: []
};

const getters = {
  newProduct(state) {
    return state.newProduct;
  },
  productList(state) {
    return state.productList;
  }
};

const actions = {
  [GET_NEW_PRODUCT](context) {
    const id = 4;
    return ApiService.get("v1/products/with_tag", `${id}?limit=50&offset=0`)
      .then(({ data }) => {
        context.commit(SET_NEW_PRODUCT, data);
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  },
  [GET_PRODUCTS_BY_TAG_ID](context, payload) {
    return ApiService.get(
      "v1/products/with_tag",
      `${payload.id}?limit=50&offset=0&sort=${payload.sort}`
    )
      .then(({ data }) => {
        context.commit(SET_PRODUCT_LIST, data);
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  },
  [GET_PRODUCTS_BY_PUBLIC_CATEGORY_NAME]({ commit }, payload) {
    let apiQuery = `limit=${payload.limit}&offset=${payload.offset}&name=${payload.name}&company_id=${COMPANY_ID}`;
    if (payload.sort) apiQuery += `&sort=${payload.sort}`;

    ApiService.get("v1/products", `public_categories?${apiQuery}`).then(
      response => {
        if (response.data.length > 0) {
          commit(SET_PRODUCT_LIST, response.data[0].products);
        } else {
          commit(SET_PRODUCT_LIST, []);
        }
      }
    );
  },
  [GET_PRODUCTS_BY_PUBLIC_CATEGORY_NAME_WITH_SORT]({ commit }, payload) {
    let apiQuery = `limit=${payload.limit}&offset=${payload.offset}&name=${payload.name}&company_id=${COMPANY_ID}`;
    if (payload.sort) apiQuery += `&sort=${payload.sort}`;

    ApiService.get("v1/products", `by_category_name?${apiQuery}`).then(
      response => {
        if (response.data.length > 0) {
          commit(SET_PRODUCT_LIST, response.data[0].products);
        } else {
          commit(SET_PRODUCT_LIST, []);
        }
      }
    );
  },
  [GET_PRODUCTS_BY_PUBLIC_TAGS_NAME]({ commit }, payload) {
    ApiService.get(
      "v1/products",
      `public_tags?limit=${payload.limit}&offset=${payload.offset}&name=${payload.name}&company_id=${COMPANY_ID}`
    )
      .then(response => {
        if (response.data.length > 0) {
          commit(SET_PRODUCT_LIST, response.data[0].products);
        } else {
          commit(SET_PRODUCT_LIST, []);
        }
      })
      .catch(() => {});
  },
  [GET_PRODUCTS_BY_PUBLIC_TAGS_NAME_WITH_SORT]({ commit }, payload) {
    let apiQuery = `limit=${payload.limit}&offset=${payload.offset}&name=${payload.name}&company_id=${COMPANY_ID}`;
    if (payload.sort) apiQuery += `&sort=${payload.sort}`;

    ApiService.get("v1/products", `by_tag_name?${apiQuery}`)
      .then(response => {
        if (response.data.length > 0) {
          commit(SET_PRODUCT_LIST, response.data[0].products);
        } else {
          commit(SET_PRODUCT_LIST, []);
        }
      })
      .catch(() => {});
  }
};

const mutations = {
  [SET_NEW_PRODUCT](state, payload) {
    state.newProduct = payload;
    state.errors = {};
  },
  [SET_PRODUCT_LIST](state, payload) {
    state.productList = payload || [];
    state.errors = {};
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
